<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M49 5H15a2 2 0 00-2 2v50a2 2 0 002 2h34a2 2 0 002-2V7a2 2 0 00-2-2zm-1 3v11.5H16V8zM16 56V22.5h32V56z"/><path d="M41.5 32H28.61a1.5 1.5 0 000 3H41.5a1.5 1.5 0 000-3z"/><circle cx="22.5" cy="33.54" r="1.5"/><path d="M41.5 43H28.61a1.5 1.5 0 000 3H41.5a1.5 1.5 0 000-3z"/><circle cx="22.5" cy="44.54" r="1.5"/></svg>